export default function TopBannerSetupFooter() {
    return (<></>)
}